import { IP_URL } from "./global";

export const postRequest = async (endpoint, data) => {
    const token = localStorage.getItem('token');
    const formData = new FormData();

    for (const key in data) {
        let dataAssign = data[key];
        if (data[key] == 'null' || data[key] === null) {
            dataAssign = '';
        }
        formData.append(key, dataAssign);
    }

    try {
        const response = await fetch(`${IP_URL}${endpoint}`, {
            method: "POST",
            headers: {
                Authorization: 'Bearer ' + token
            },
            body: formData
        });

        if (!response.ok) {
            // If the response is not ok, throw an error to be caught in the catch block
            throw new Error(`Server error: ${response.status} ${response.statusText}`);
        }

        const returnData = await response.json();
        return returnData;

    } catch (error) {
        console.error("An error occurred during the POST request:", error);
        // Return a meaningful error message or handle it as needed
        return { success: false, message: "An error occurred. Please try again later." };
    }
}


export const getRequest = async (endpoint, data) => {
    const token = localStorage.getItem('token');
    // console.log(data);
    const params = new URLSearchParams(data);

    const response = await fetch(`${IP_URL}${endpoint}?${params}`, {
        method: "get",
        headers: {
            // "Content-Type": "application/json",
            Authorization: 'Bearer ' + token
        },
    });
    // console.log(IP_URL, "url")
    const returndata = await response.json();
    //  console.log(returndata);
    return returndata;
}

export const patchRequest = async () => {

}

export const deleteRequest = async () => {

}

